import { render, staticRenderFns } from "./SeleccionCliente.vue?vue&type=template&id=902bf85c"
import script from "./SeleccionCliente.vue?vue&type=script&lang=js"
export * from "./SeleccionCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports